// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('configuration.freightCosts', {
    url: '/freightcosts',
    templateUrl: 'main/configuration/freightCosts/freightCosts.tpl.html',
    data: { pageTitle: 'Freight costs' },
  });
};

angular.module('configuration.freightCosts', []).config(config);
